import { fetchPaginatedJobs } from '@/api/fota'
import {
  ConfirmErrorState,
  ConfirmTimeoutState,
  DownloadErrorState,
  DownloadReadyState,
  DownloadTimeoutState,
  InstallErrorState,
  UpdateTimeoutState,
} from '@/pages/fota/jobState'

export const fotaTabCountsLoader = async () => {
  try {
    const [errorJobs, installedJobs, updateReadyJobs] = await Promise.all([
      fetchPaginatedJobs({
        page: 0,
        pageSize: 1,
        sortBy: 'created_at',
        sortDir: 'desc',
        searchTerm: '',
        state: [
          DownloadTimeoutState,
          UpdateTimeoutState,
          DownloadErrorState,
          InstallErrorState,
          ConfirmErrorState,
          ConfirmTimeoutState,
        ],
      }),
      fetchPaginatedJobs({
        page: 0,
        pageSize: 1,
        sortBy: 'created_at',
        sortDir: 'desc',
        searchTerm: '',
        state: ['Installed'],
      }),
      fetchPaginatedJobs({
        page: 0,
        pageSize: 1,
        sortBy: 'created_at',
        sortDir: 'desc',
        searchTerm: '',
        state: [DownloadReadyState],
      }),
    ])

    return {
      errorCount: errorJobs.totalRows,
      installedCount: installedJobs.totalRows,
      updateReadyCount: updateReadyJobs.totalRows,
    }
  } catch (error) {
    console.error('Error fetching FOTA tab counts:', error)
    return {
      errorCount: 0,
      installedCount: 0,
      updateReadyCount: 0,
    }
  }
}

export const errorJobsLoader = async ({ request }: { request: Request }) => {
  try {
    const url = new URL(request.url)
    const page = Number.parseInt(url.searchParams.get('page') ?? '1', 10)
    const pageSize = Number.parseInt(
      url.searchParams.get('pageSize') ?? '10',
      10,
    )
    const sortBy = url.searchParams.get('sortBy') ?? 'created_at'
    const sortDir = (url.searchParams.get('sortDir') ?? 'desc') as
      'asc' | 'desc'
    const searchTerm = url.searchParams.get('search') ?? ''

    const { data, totalRows } = await fetchPaginatedJobs({
      page,
      pageSize,
      sortBy,
      sortDir,
      searchTerm,
      state: [
        DownloadTimeoutState,
        UpdateTimeoutState,
        DownloadErrorState,
        InstallErrorState,
        ConfirmErrorState,
        ConfirmTimeoutState,
      ],
    })

    return { data, totalRows }
  } catch (error) {
    console.error('Error in errorJobsLoader:', error)
    return { data: [], totalRows: 0 }
  }
}

export const installedJobsLoader = async ({
  request,
}: {
  request: Request
}) => {
  try {
    const url = new URL(request.url)
    const page = Number.parseInt(url.searchParams.get('page') ?? '1', 10)
    const pageSize = Number.parseInt(
      url.searchParams.get('pageSize') ?? '10',
      10,
    )
    const sortBy = url.searchParams.get('sortBy') ?? 'created_at'
    const sortDir = (url.searchParams.get('sortDir') ?? 'desc') as
      'asc' | 'desc'
    const searchTerm = url.searchParams.get('search') ?? ''

    const { data, totalRows } = await fetchPaginatedJobs({
      page,
      pageSize,
      sortBy,
      sortDir,
      searchTerm,
      state: ['Installed'],
    })

    return { data, totalRows }
  } catch (error) {
    console.error('Error in installedJobsLoader:', error)
    return { data: [], totalRows: 0 }
  }
}

export const allJobsLoader = async ({ request }: { request: Request }) => {
  try {
    const url = new URL(request.url)
    const page = Number.parseInt(url.searchParams.get('page') ?? '1', 10)
    const pageSize = Number.parseInt(
      url.searchParams.get('pageSize') ?? '10',
      10,
    )
    const sortBy = url.searchParams.get('sortBy') ?? 'created_at'
    const sortDir = (url.searchParams.get('sortDir') ?? 'desc') as
      'asc' | 'desc'
    const searchTerm = url.searchParams.get('search') ?? ''

    const { data, totalRows } = await fetchPaginatedJobs({
      page,
      pageSize,
      sortBy,
      sortDir,
      searchTerm,
      state: [],
    })

    return { data, totalRows }
  } catch (error) {
    console.error('Error in allJobsLoader:', error)
    return { data: [], totalRows: 0 }
  }
}

export const updateReadyJobsLoader = async ({
  request,
}: {
  request: Request
}) => {
  try {
    const url = new URL(request.url)
    const page = Number.parseInt(url.searchParams.get('page') ?? '1', 10)
    const pageSize = Number.parseInt(
      url.searchParams.get('pageSize') ?? '10',
      10,
    )
    const sortBy = url.searchParams.get('sortBy') ?? 'created_at'
    const sortDir = (url.searchParams.get('sortDir') ?? 'desc') as
      'asc' | 'desc'
    const searchTerm = url.searchParams.get('search') ?? ''

    const { data, totalRows } = await fetchPaginatedJobs({
      page,
      pageSize,
      sortBy,
      sortDir,
      searchTerm,
      state: [DownloadReadyState],
    })

    return { data, totalRows }
  } catch (error) {
    console.error('Error in updateReadyJobsLoader:', error)
    return { data: [], totalRows: 0 }
  }
}

export const createJobLoader = async () => {
  try {
    const { data, totalRows } = await fetchPaginatedJobs({
      page: 0,
      pageSize: 1,
      sortBy: 'created_at',
      sortDir: 'desc',
      searchTerm: '',
      state: [],
    })

    return { data, totalRows }
  } catch (error) {
    console.error('Error in createJobLoader:', error)
    return { data: [], totalRows: 0 }
  }
}
